import { memo } from 'react';
import { ShimmerLine } from "../../../commonComponents/ShimmerLine";

const ContentBlock = memo(() => (
  <>
    <div className="space-y-3 mb-3">
      <div className="flex justify-between items-center">
        <ShimmerLine className="!h-5 !w-3/4 rounded-[18px]" />
        <ShimmerLine className="!h-4 !max-w-5 rounded-[18px]" />
      </div>
      <ShimmerLine className="!h-2.5 !w-[65%] rounded-[18px]" />
    </div>
    <div className="border-b border-gray-100 my-3 last:hidden" />
  </>
));

ContentBlock.displayName = 'ContentBlock';

const ShimmerSkeleton = memo(() => {
  return (
    <div className="w-full max-w-2x mt-4 bg-white p-6 rounded-[18px] shadow-[0px_0px_12px0px#A238FF0D]">
      <div className="flex justify-between mb-8 gap-4">
        {Array.from({ length: 3 }, (_, index) => (
          <ShimmerLine
            key={index}
            className={`!h-5 !w-[84px] rounded-[18px]`}
          />
        ))}
      </div>

      {Array.from({ length: 3 }, (_, index) => (
        <ContentBlock key={`content-${index}`} />
      ))}
    </div>
  );
});

ShimmerSkeleton.displayName = 'ShimmerSkeleton';

export default ShimmerSkeleton;